import { createPortal } from "react-dom";

function RefundPolicy({ onClose }) {
  return createPortal(
    <div style={overlayStyle}>
      <div style={boxStyle}>

        {/* Header */}
        <div style={headerStyle}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "28px" }}>💰</span>
            <div>
              <h4 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#111" }}>
                Refund Policy
              </h4>
              <p style={{ margin: 0, fontSize: "12px", color: "#777" }}>
                Shopeindia — Effective Date: January 1, 2026
              </p>
            </div>
          </div>
          <button onClick={onClose} style={closeBtnStyle}>✕</button>
        </div>

        {/* Content */}
        <div style={contentStyle}>

          <p style={paraStyle}>
            At <b>Shopeindia</b>, we strive to ensure complete customer satisfaction. This Refund Policy outlines the conditions under which refunds will be processed for orders placed on <b>www.shopeindia.co.in</b>.
          </p>

          <Section title="1. Refund Eligibility">
            <p style={paraStyle}>You are eligible for a refund in the following cases:</p>
            <ul style={listStyle}>
              <li>You received a <b>damaged or defective product</b></li>
              <li>You received a <b>wrong product</b> (different from what you ordered)</li>
              <li>Your order was <b>lost in transit</b> and not delivered within 15 business days</li>
              <li>Your order was <b>cancelled within 24 hours</b> of placement and before dispatch</li>
              <li>Duplicate payment was made due to a technical error</li>
            </ul>
          </Section>

          <Section title="2. Non-Refundable Cases">
            <p style={paraStyle}>Refunds will <b>NOT</b> be issued in the following cases:</p>
            <ul style={listStyle}>
              <li>Product has been used, assembled, or damaged by the customer</li>
              <li>Request is made after <b>7 days</b> of delivery</li>
              <li>Product packaging is opened for hygiene-sensitive items (e.g., lancets, needles)</li>
              <li>Digital products (e-books, online courses) once accessed or downloaded</li>
              <li>Change of mind or incorrect order placed by customer</li>
              <li>Products marked as <b>"Non-Returnable"</b> on the product page</li>
            </ul>
          </Section>

          <Section title="3. How to Request a Refund">
            <p style={paraStyle}>To initiate a refund request:</p>
            <ul style={listStyle}>
              <li>Contact us within <b>7 days</b> of receiving your order</li>
              <li>Email us at <b>support@shopeindia.co.in</b> with your Order ID, issue description, and photos/video of the damaged/wrong product</li>
              <li>Alternatively, call us at <b>+91 7385743121</b></li>
              <li>Our team will review your request within <b>2–3 business days</b></li>
            </ul>
          </Section>

          <Section title="4. Refund Process & Timeline">
            <ul style={listStyle}>
              <li>Once your refund is approved, it will be processed within <b>5–7 business days</b></li>
              <li>Refund will be credited to your <b>original payment method</b> (UPI, card, bank account)</li>
              <li>For COD orders, refund will be processed via <b>bank transfer or UPI</b> — please share your bank details when raising the request</li>
              <li>Depending on your bank, it may take an additional 2–5 days to reflect in your account</li>
            </ul>
          </Section>

          <Section title="5. Cancellation Refunds">
            <ul style={listStyle}>
              <li>Orders cancelled within <b>24 hours</b> of placement (before dispatch): <b>100% refund</b></li>
              <li>Orders cancelled after dispatch: refund will be initiated only after the product is returned and inspected</li>
              <li>Cancellation requests must be sent to <b>support@shopeindia.co.in</b> with your Order ID</li>
            </ul>
          </Section>

          <Section title="6. Payment Gateway Refunds">
            <p style={paraStyle}>
              If your payment was deducted but the order was not confirmed, the amount will be automatically refunded to your original payment method within <b>5–7 business days</b>. If you do not receive the refund within this period, please contact your bank or payment provider and also reach out to us.
            </p>
          </Section>

          <Section title="7. Shipping Charges on Refund">
            <ul style={listStyle}>
              <li>If the return/refund is due to our error (wrong/damaged product), <b>shipping charges are fully refunded</b></li>
              <li>If the return is due to customer's change of mind, original shipping charges are <b>non-refundable</b></li>
              <li>Return shipping costs are borne by the customer unless the error is on our end</li>
            </ul>
          </Section>

          <Section title="8. Contact Us">
            <p style={paraStyle}><b>Shopeindia</b></p>
            <p style={paraStyle}><b>Address:</b> Shopeindia, Warud, Maharashtra, India</p>
            <p style={paraStyle}><b>Phone:</b>+91 7385743121</p>
            <p style={paraStyle}><b>Email:</b>support@shopeindia.co.in</p>
            <p style={paraStyle}><b>Timings:</b> Monday to Saturday, 10:00 AM – 6:00 PM</p>
          </Section>

        </div>

        {/* Footer */}
        <div style={actionsStyle}>
          <button onClick={onClose} style={acceptBtnStyle}>
            ✓ I Understand
          </button>
          <button onClick={onClose} style={cancelBtnStyle}>
            Close
          </button>
        </div>

      </div>
    </div>,
    document.body
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "18px" }}>
      <h5 style={{ fontSize: "14px", fontWeight: "700", color: "#24aeb1", marginBottom: "8px", borderBottom: "1px solid #e8f8f8", paddingBottom: "4px" }}>
        {title}
      </h5>
      {children}
    </div>
  );
}

const overlayStyle = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 99999, padding: "16px" };
const boxStyle = { background: "#fff", width: "100%", maxWidth: "720px", borderRadius: "16px", display: "flex", flexDirection: "column", maxHeight: "90vh", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden" };
const headerStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "2px solid #e8f8f8", background: "#f7fffe", flexShrink: 0 };
const closeBtnStyle = { background: "#f1f5f9", border: "none", width: "32px", height: "32px", borderRadius: "50%", fontSize: "16px", cursor: "pointer", color: "#475569" };
const contentStyle = { overflowY: "auto", padding: "20px 24px", flex: 1, fontSize: "13.5px", color: "#444", lineHeight: "1.7" };
const paraStyle = { marginBottom: "8px" };
const listStyle = { paddingLeft: "20px", marginBottom: "8px", display: "flex", flexDirection: "column", gap: "4px" };
const actionsStyle = { display: "flex", gap: "10px", justifyContent: "flex-end", padding: "14px 24px", borderTop: "1px solid #eee", flexShrink: 0 };
const acceptBtnStyle = { background: "#24aeb1", color: "#fff", border: "none", padding: "10px 24px", borderRadius: "8px", fontWeight: "600", fontSize: "14px", cursor: "pointer" };
const cancelBtnStyle = { background: "#f1f5f9", color: "#333", border: "none", padding: "10px 20px", borderRadius: "8px", fontWeight: "500", fontSize: "14px", cursor: "pointer" };

export default RefundPolicy;